import { Dialog } from "@mui/material";
import { useEffect } from "react";
import { FaRegCheckCircle } from "react-icons/fa";

const SuccessAddCartPopup = ({ open, setOpen, closeFunc }) => {
  const handleClose = () => {
    closeFunc();
    setOpen(false);
  };

  useEffect(() => {
    if (open)
      setTimeout(() => {
        handleClose();
      }, 1500);
  }, [open]);

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      PaperProps={{ sx: { borderRadius: "16px" } }}
    >
      <div className="flex gap-4 items-start p-4 bg-[#F1FAF0] text-[#4FB33C]">
        <FaRegCheckCircle className="text-[20px] mt-1" />
        <div className="w-full">
          <p className="text-[20px]">Berhasil</p>
          <p className="text-[16px]">
            Produk berhasil ditambahkan ke keranjang
          </p>
        </div>
      </div>
    </Dialog>
  );
};

export default SuccessAddCartPopup;
